import { motion } from "framer-motion";

const images = [
  {
    url: "https://images.unsplash.com/photo-1635424709961-f3a150459ad4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHw0fHxyb29maW5nJTIwY29udHJhY3RvciUyMHdvcmtlcnN8ZW58MHx8fHwxNzg1NTUwOTA5fDA&ixlib=rb-4.1.0&q=85",
    label: "Experienced crews on the job",
    span: "md:col-span-2 md:row-span-2",
  },
  {
    url: "https://images.unsplash.com/photo-1755114203680-d39d95efa82c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxkcm9uZSUyMHNob3QlMjByb29mfGVufDB8fHx8MTc4NTU1MDkwOXww&ixlib=rb-4.1.0&q=85",
    label: "Drone-inspected precision",
    span: "",
  },
  {
    url: "https://images.unsplash.com/photo-1777106322601-578dc9213ace?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjByb29mJTIwc3VidXJiYW4lMjBob21lfGVufDB8fHx8MTc4NTU1MDkwOXww&ixlib=rb-4.1.0&q=85",
    label: "A brand-new roof, finished right",
    span: "",
  },
];

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="relative py-28 md:py-36 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-14">
          <p className="text-xs uppercase tracking-[0.3em] text-hero-red mb-4">— Our Work</p>
          <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] max-w-3xl">
            Roofs that make the neighbors look twice.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 auto-rows-[220px] md:auto-rows-[260px] gap-5">
          {images.map((img, i) => (
            <motion.div
              key={i}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className={`group relative overflow-hidden clip-frame border border-white/10 ${img.span}`}
            >
              <img
                src={img.url}
                alt={img.label}
                className="w-full h-full object-cover grayscale-[30%] group-hover:grayscale-0 group-hover:scale-105 transition-[transform,filter] duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-hero-void/90 via-transparent to-transparent" />
              <span className="absolute bottom-5 left-5 font-medium text-sm text-white/90">{img.label}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
